<template>
  <div class="popup_wrap" style="width:800px;">
    <button
      type="button"
      class="layer_close"
      @click="$emit('close')"
    >
      close
    </button>
    <div class="popup_cont">
      <h1 class="page_title">{{ $t('msg.hsCdPop.014') }}</h1> <!-- HS Code 조회 -->
      <div class="content_box">
        <div class="clearfix">
          <span class="tit_label">Country</span>
          <select v-model="ctrCd" style="width:170px;">
            <option v-for="vo in ctrCdList" :key="vo.cd" :value="vo.cd">{{ vo.cdNm }}</option>
          </select>
          <span class="tit_label ml10">Code</span>
          <input v-model="hsCd" type="text" style="width:100px;" maxlength="12" @keyup.enter="searchHsCd()">
          <span class="tit_label ml10">Name</span>
          <input v-model="hsNm" type="text" style="width:160px;" @keyup.enter="searchHsCd()">
          <a class="button blue sh ml10" @click.prevent="searchHsCd()">{{ $t('msg.CMBA100.528') }}</a> <!-- 검색 -->
        </div>
      </div>
      <div class="content_box mt10">
        <div ref="listArea" class="hs_cd_list" @scroll="onScroll">
          <table class="tbl_col">
            <colgroup>
              <col width="12%">
              <col width="18%">
              <col width="70%">
            </colgroup>
            <thead>
              <tr>
                <th>Country</th>
                <th>Code</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="vo in hsCdList" :key="vo.cd">
                <td>{{ vo.cdId }}</td>
                <td>{{ vo.cd }}</td>
                <td class="text_left">{{ vo.cdNm }}</td>
              </tr>
              <tr v-if="hsCdList.length === 0 && !loading">
                <td colspan="3">{{ $t('msg.ONEX010T010.073') }}</td> <!-- 검색 결과가 없습니다. -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import transCommon from '@/api/rest/trans/transCommon'

const PAGE_SIZE = 100

export default {
  name: 'HsCodeSearchPop',
  props: {
    parentInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      ctrCdList: [],
      ctrCd: 'AL',
      hsCd: '',
      hsNm: '',
      hsCdList: [],
      searchCond: {}, // 검색 버튼 누른 시점의 조건 (스크롤로 이어 받을 때 사용)
      searchSeq: 0, // 새로 검색하면 증가 → 이전 검색의 늦은 응답은 버림
      loading: false,
      isLast: false
    }
  },
  created () {
    transCommon.getHsCdCtrList().then(res => {
      this.ctrCdList = res.data || []
    })
    this.searchHsCd()
  },
  methods: {
    searchHsCd () {
      this.searchSeq++
      this.searchCond = { ctrCd: this.ctrCd, hsCd: this.hsCd, hsNm: this.hsNm }
      this.hsCdList = []
      this.loading = false
      this.isLast = false
      if (this.$refs.listArea) {
        this.$refs.listArea.scrollTop = 0
      }
      this.loadNextPage()
    },
    // 무한 스크롤: 지금까지 받은 마지막 코드 다음부터 PAGE_SIZE 건
    loadNextPage () {
      if (this.loading || this.isLast) {
        return
      }
      const seq = this.searchSeq
      const lastVo = this.hsCdList[this.hsCdList.length - 1]
      this.loading = true
      transCommon.getHsCdList({
        ...this.searchCond,
        lastHsCd: lastVo ? lastVo.cd : '',
        pageSize: PAGE_SIZE
      }, !lastVo).then(res => {
        if (seq !== this.searchSeq) {
          return
        }
        const list = res.data || []
        // 계속 늘어나는 목록이라 반응형 변환 생략
        this.hsCdList = Object.freeze(this.hsCdList.concat(list))
        this.isLast = list.length < PAGE_SIZE
      }).finally(() => {
        if (seq === this.searchSeq) {
          this.loading = false
        }
      })
    },
    onScroll (e) {
      const el = e.target
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 100) {
        this.loadNextPage()
      }
    }
  }
}
</script>

<style scoped>
.hs_cd_list { overflow-y: auto; max-height: 450px; }
/* collapse 표에서는 고정 헤더 윗부분으로 스크롤된 행 글자가 비쳐 보여 separate 로 (셀마다 위·왼쪽 테두리만 있어 모양 동일) */
.hs_cd_list table { border-collapse: separate; border-spacing: 0; }
.hs_cd_list thead th { position: sticky; top: 0; z-index: 1; }
</style>
